import { render, staticRenderFns } from "./TwoFactorVerify.vue?vue&type=template&id=1f2f6b90&"
import script from "./TwoFactorVerify.vue?vue&type=script&lang=js&"
export * from "./TwoFactorVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports